import {isCell, isLayout} from '@packages/utilities/elementTypeUtils';
import {type ExpressionElement} from '@packages/systems/wfdl-ast';

/**
 * Checks for edge case Layout element paste events
 */
const isRestrictedLayoutPasteEvent = (
  selectedElement: ExpressionElement,
  pastedElement: ExpressionElement
) => {
  if (isCell(selectedElement) && isCell(pastedElement)) {
    return {restricted: true};
  }
  if (isLayout(selectedElement) && isCell(pastedElement)) {
    return {restricted: true, error: 'A cell can only be pasted into a cell.'};
  }
  return {restricted: false};
};

export default isRestrictedLayoutPasteEvent;
